import React from 'react';

/**
 * Locks the page's scroll while `active` is true, restoring the previous styles on deactivation or unmount.
 * The page scrolls on the root element (html sets its own overflow-y), so the root is locked as well as the body:
 * locking the body alone left the page scrolling behind dialogs (2026-10-28). Where the page had a scrollbar its
 * gutter is kept, so the page doesn't shift sideways.
 */
export function useBodyScrollLock(active: boolean) {
  React.useEffect(() => {
    if (!active) return;
    const root = document.documentElement;
    const { body } = document;
    const previous = { body: body.style.overflow, root: root.style.overflow, gutter: root.style.scrollbarGutter };
    const hadScrollbar = window.innerWidth > root.clientWidth;
    body.style.overflow = 'hidden';
    root.style.overflow = 'hidden';
    if (hadScrollbar) root.style.scrollbarGutter = 'stable';
    return () => {
      body.style.overflow = previous.body;
      root.style.overflow = previous.root;
      root.style.scrollbarGutter = previous.gutter;
    };
  }, [active]);
}

export default useBodyScrollLock;
